// @flow
import React, {
  type Element,
  // $FlowFixMe
  useMemo,
  Fragment,
  // $FlowFixMe
  useState,
  // $FlowFixMe
  useEffect
} from "react";
import { noop, map, get, find } from "lodash";
import Icon from "@fdr/static-ui/Icons";
import { numberFire, info, bets } from "@fdr/static-ui/Icons/icons";
import { useNextRaceUrl } from "@fdr/custom-hooks/ProgramPage";
import { RacecardMask } from "@fdr/static-ui/Masks";
import {
  FixedMessage,
  FloatingBanner
} from "@fdr/atomic-ui/_molecules/MessageV2";
import { LinkAction } from "@fdr/atomic-ui/_molecules/MessageV2/types";
import { onOpenComplianceModal } from "@tvg/sh-lib-account-wallet/src/utils/mobileUtils";
import type {
  NullaryFn,
  UnaryFn,
  BinaryFn,
  TernaryFn
} from "@tvg/types/Functional";
import type {
  RaceCardBettingInterest,
  RaceTypeCodeEnum,
  RaceListItem,
  RaceProgram,
  RunnerTagsModalProps
} from "@tvg/types/Race";
import type { PastPerformanceRace } from "@fdr/types/PastPerformance";
import type { HelpTypeEnum } from "@fdr/types/ProgramPage";
import buildRaceUrl from "@tvg/formatter/url";
import buildColor from "@fdr/static-ui/ColorPalette";
import type { WagerGroupEnum } from "@fdr/types/WagerTypes";
import { createPortal } from "react-dom";
import NumberFire from "@fdr/static-ui/SvgImages/NumberFire";
import RacingAndSports from "@fdr/static-ui/SvgImages/RacingAndSports";
import VideoPlaylist from "@fdr/video-builder/src/index";
import { JWPlayerProgramPageResponse } from "@fdr/video-builder/src/types";
import { events as AlchemerEvents } from "@urp/alchemer";
import { FilterButton, Paragraph } from "@tvg/design-system/web";
import { isURP } from "@tvg/utils/generalUtils";
import MagnetScrollArea from "../MagnetScrollArea";
import RunnerList, { type Selections } from "../../_organisms/RunnerList";
import RaceInfoInline from "../../_atoms/RaceInfoInline";
import Button from "../../_atoms/Button";
import {
  RaceCardSection,
  RaceCardLegWrapper,
  RaceCardWrapper,
  RaceCardTable,
  NumberFireTable,
  NumberFireTitle,
  LegInfoContainer,
  LegInfoWrapper,
  RaceNumber,
  LegTitle,
  LegCard,
  NumberFireInfo,
  NumberFireText,
  NumberFireIcon,
  LegInfoIconsWrapper,
  LegInfoIconButton,
  FixedMessageContainer,
  InlineMessageWrapper,
  InlineMessageButtons,
  FloatingBannerWrapper,
  VideoSectionWrapper,
  FilterBarWrapper,
  LegNavigatorContainer
} from "./styled-components";
import { InlineMessage } from "../../_molecules/MessageV2";
import RaceTip from "../../_molecules/RaceTip";
import { getRunnersHandicapping } from "../../_organisms/RaceSelector";
import ComponentSection from "../../_organisms/ComponentSection";

type Props = {
  /**
   * Array of the Race Betting Interests
   */
  bettingInterests: Array<Array<RaceCardBettingInterest>>,
  /**
   * Race type code
   */
  raceTypeCode: RaceTypeCodeEnum,
  /**
   * Flag that controls if the race is wagerable or not
   */
  isWagerable: boolean,
  /**
   * Array with the current selections of the RaceCard
   */
  selections: Selections,
  /**
   * Number of selection columns
   */
  numColumns: number,
  /**
   * To confirm, that all runners are selected
   */
  isAllSelected: Array<boolean>,
  /**
   * Calback to run when user selects a runner
   */
  onRunnerSelect: BinaryFn<string, number, mixed>,
  /**
   * selected leg on pick bets
   */
  selectedLeg: number,
  /**
   * Callback to run when change the selected leg for pick bets
   */
  onLegSelect: UnaryFn<number, void>,
  onSelectAllRunnerEntries: UnaryFn<string, void>,
  isLogged: boolean,
  renderSortComponent: NullaryFn<mixed>,
  racesData: Array<?(RaceListItem[])>,
  race: RaceProgram | PastPerformanceRace,
  races: RaceProgram[],
  expandedInfo: TernaryFn<number, number, boolean, Element<*> | void>,
  updatePicks: boolean,
  changeUpdate: TernaryFn<string, number, boolean, void>,
  hasRequested: boolean,
  selectedRunners: string[][],
  changeShouldUpdate: UnaryFn<boolean, void>,
  changeRace: BinaryFn<string, string, void>,
  openHelpModal: UnaryFn<HelpTypeEnum, void>,
  hasRaceAlertsBar: boolean,
  /**
   * The race alerts component
   */
  renderRaceAlerts: TernaryFn<boolean, number, number, mixed>,
  /**
   * numberFirePrediction Toggle
   */
  numberFirePrediction: boolean,
  hasNumberFirePredictions: boolean,
  /**
   * Show win prob on runner line, hides the expandable icon
   */
  showWinProb: boolean,
  betAmount: number,
  /*
   * If is an Sky Racing World race
   */
  isSRW: boolean,
  /*
   * If Racing and Sports race
   */
  isRAS: boolean,
  freePickSource: string,
  /*
   * Toggle verdict expanded
   */
  raceAnalystVerdictExpanded: boolean,
  /*
   * Method to handle toggle verdict expanded
   */
  setRaceAnalystVerdictExpanded: UnaryFn<boolean, void>,
  /*
   * Toggle for program page layout revamp
   */
  useNewProgramPageLayout: boolean,
  activeBetsCounter: number,
  openBetReceiptModal: NullaryFn<void>,
  /*
   * Bet group identify
   */
  group: ?WagerGroupEnum,
  /*
   * Full width in bet selection
   */
  fullWidth: boolean,
  /*
   * Toggle for when is race card inside results page
   */
  isResulted?: boolean,
  /*
   * Toggle for the Active bets receipt
   */
  hasProgramPageActiveBetsReceipt: boolean,
  isBettingModalOpen: boolean,
  showOnboardingInfo: boolean,
  showSilks: boolean,
  internationalLabel: string,
  shouldShowFirstOnboarding: boolean,
  onTooltipClick: NullaryFn<void>,
  setOnboardingStatus: BinaryFn<string, string, void>,
  useGraphStatusV2?: boolean,
  showRunnerUpdate: boolean,
  isAccountCompliant?: boolean,
  enableNewRacePage: boolean,
  isInfoBannerVisible: boolean,
  infoBannerLink?: LinkAction,
  onCloseInfoBanner?: NullaryFn<void>,
  wagerTypeCode?: string,
  onRaceTagsInfoClick?: UnaryFn<RunnerTagsModalProps, void>,
  videoCarouselData?: JWPlayerProgramPageResponse,
  selectAllButtonLabel?: string,
  raceDate?: string,
  talentPicksComp?: Element<*>,
  videoCarouselData?: JWPlayerProgramPageResponse,
  numLegs?: number
};

const RaceCard = (props: Props) => {
  const {
    bettingInterests,
    raceTypeCode,
    isWagerable,
    selections,
    numColumns,
    onRunnerSelect,
    selectedLeg,
    onLegSelect,
    onSelectAllRunnerEntries,
    isLogged,
    renderSortComponent,
    racesData,
    race,
    races,
    expandedInfo,
    updatePicks,
    changeUpdate,
    hasRequested,
    selectedRunners,
    changeShouldUpdate,
    changeRace,
    openHelpModal,
    renderRaceAlerts,
    hasRaceAlertsBar,
    numberFirePrediction,
    hasNumberFirePredictions,
    showWinProb,
    betAmount,
    isSRW,
    isRAS,
    freePickSource,
    raceAnalystVerdictExpanded,
    setRaceAnalystVerdictExpanded,
    useNewProgramPageLayout,
    openBetReceiptModal,
    activeBetsCounter,
    group,
    fullWidth,
    isResulted,
    hasProgramPageActiveBetsReceipt,
    isBettingModalOpen,
    showOnboardingInfo,
    showSilks,
    internationalLabel,
    shouldShowFirstOnboarding,
    onTooltipClick,
    setOnboardingStatus,
    useGraphStatusV2,
    showRunnerUpdate,
    isAccountCompliant,
    enableNewRacePage,
    isInfoBannerVisible,
    infoBannerLink,
    onCloseInfoBanner,
    wagerTypeCode,
    onRaceTagsInfoClick,
    videoCarouselData,
    selectAllButtonLabel,
    raceDate,
    talentPicksComp,
    numLegs
  } = props;
  const { nextRace, forwardDisabled } = useNextRaceUrl(races, race);
  // $FlowFixMe
  const [parentContainer, setParentContainer] = useState<HTMLElement>();
  const [swipeController, setSwipeController] = useState(null);

  // $FlowFixMe
  useEffect(() => {
    const betTicketSection = document.getElementById("bet-ticket-section");
    setParentContainer(betTicketSection);
  }, [isBettingModalOpen]);

  const renderLegInfo = (
    leg: number,
    isLeg: boolean = false,
    tvgRaceId: number
  ) => {
    const runnersHandicapping = getRunnersHandicapping(
      [bettingInterests[leg]],
      freePickSource
    );

    const raceNumber = +get(race, "raceNumber");
    const timeformAnalystVerdict = get(
      races[leg + raceNumber - 1],
      "timeform.analystVerdict",
      ""
    );
    const raceType = get(races[leg + raceNumber - 1], "type.code", "T");
    const isInCurrentRace = get(race, "tvgRaceId", 0) === tvgRaceId;
    const showActiveBets =
      isInCurrentRace &&
      isLogged &&
      !isResulted &&
      hasProgramPageActiveBetsReceipt;
    const showRaceAlets =
      isInCurrentRace && useNewProgramPageLayout && hasRaceAlertsBar;
    return (
      <LegInfoContainer>
        <LegInfoWrapper isNewLayout={useNewProgramPageLayout}>
          <RaceNumber isNewLayout={useNewProgramPageLayout}>
            <LegTitle>
              {bettingInterests.length <= 1
                ? `Race ${leg + +get(race, "raceNumber", "")}`
                : `Leg ${leg + 1} of ${bettingInterests.length}`}
              {bettingInterests.length > 1 && (
                <span>Race {leg + +get(race, "raceNumber", "")}</span>
              )}
            </LegTitle>
            <LegInfoIconsWrapper>
              {isURP && showActiveBets && (
                <LegInfoIconButton
                  data-qa-label="leg-info-icon-button"
                  on={!!activeBetsCounter}
                  onClick={
                    isAccountCompliant
                      ? openBetReceiptModal
                      : onOpenComplianceModal
                  }
                >
                  <Icon
                    icon={bets}
                    size={16}
                    color={buildColor("blue", "500")}
                  />
                </LegInfoIconButton>
              )}
              {showRaceAlets && renderRaceAlerts(!isLeg, tvgRaceId, leg)}
            </LegInfoIconsWrapper>
          </RaceNumber>
          <RaceInfoInline
            isIconShown={useNewProgramPageLayout}
            raceData={racesData[leg + +get(race, "raceNumber") - 1]}
            textColor={buildColor("grey", "800")}
          />
          {useNewProgramPageLayout &&
            runnersHandicapping &&
            runnersHandicapping.length > 0 &&
            isWagerable && (
              <RaceTip
                runnersHandicapping={runnersHandicapping}
                timeformAnalystVerdict={timeformAnalystVerdict}
                raceType={raceType}
                raceAnalystVerdictExpanded={raceAnalystVerdictExpanded}
                setRaceAnalystVerdictExpanded={setRaceAnalystVerdictExpanded}
                isSRW={false}
                isRAS={isRAS}
                useNewProgramPageLayout={useNewProgramPageLayout}
              />
            )}
        </LegInfoWrapper>
      </LegInfoContainer>
    );
  };

  const renderRunnerList = (bi, leg, isLeg, tvgRaceId, isNumberFireSection) => (
    <RunnerList
      wagerTypeCode={wagerTypeCode}
      currentRace={races[leg + +get(race, "raceNumber") - 1]}
      openHelpModal={openHelpModal}
      selectedRunners={selectedRunners}
      changeUpdate={changeUpdate}
      expandedInfo={expandedInfo}
      betAmount={betAmount}
      runners={bi}
      leg={leg}
      isLeg={isLeg}
      selections={isLeg && numColumns <= 1 ? [selections[leg]] : selections}
      isWagerable={isWagerable}
      onRunnerSelect={onRunnerSelect}
      raceTypeCode={raceTypeCode}
      numColumns={numColumns}
      onSelectAllRunnerEntries={onSelectAllRunnerEntries}
      isLogged={isLogged}
      isNumberFireSection={isNumberFireSection}
      showWinProb={showWinProb}
      isSRW={isSRW}
      isRAS={isRAS}
      freePickSource={freePickSource}
      group={group}
      fullWidth={fullWidth}
      showSilks={showSilks}
      internationalLabel={internationalLabel}
      shouldShowFirstOnboarding={shouldShowFirstOnboarding}
      onTooltipClick={onTooltipClick}
      setOnboardingStatus={setOnboardingStatus}
      useGraphStatusV2={useGraphStatusV2}
      bettingInterests={bettingInterests}
      showRunnerUpdate={showRunnerUpdate}
      enableNewRacePage={enableNewRacePage}
      onRaceTagsInfoClick={onRaceTagsInfoClick}
      selectAllButtonLabel={selectAllButtonLabel}
    />
  );

  const renderBettingClosedMessage = () => (
    <InlineMessageWrapper>
      <InlineMessage
        type="warning"
        title="Race off"
        text="Betting is now closed on this race."
      >
        <InlineMessageButtons>
          <Button
            isInternalLink
            type="secondary"
            size="big"
            text="Change Track"
            url="/tracks"
            onClick={() => changeRace("Change Track", `/tracks`)}
            qaLabel="inline-msg-btn-change-track"
          />
          {!forwardDisabled && (
            <Button
              isInternalLink
              type="primary"
              size="big"
              text="Next Race"
              url={buildRaceUrl(
                get(race, "track.trackCode", ""),
                get(race, "track.trackName", ""),
                nextRace
              )}
              onClick={() =>
                changeRace(
                  "Next Race",
                  buildRaceUrl(
                    get(race, "track.trackCode", ""),
                    get(race, "track.trackName", ""),
                    nextRace
                  )
                )
              }
            />
          )}
        </InlineMessageButtons>
      </InlineMessage>
    </InlineMessageWrapper>
  );

  const renderLegRaceCard = (
    bi: RaceCardBettingInterest[],
    leg: number = 0,
    isLeg: boolean = false,
    tvgRaceId: number
  ) => {
    return (
      <Fragment>
        <LegCard isLeg={isLeg}>
          {isLeg && renderLegInfo(leg, isLeg, tvgRaceId)}
          {!isWagerable &&
            get(race, "status.code", "RO") === "SK" &&
            renderBettingClosedMessage()}
          {renderSortComponent()}
          {get(bettingInterests, "length") > 0 && hasRequested ? (
            <RaceCardWrapper>
              <RaceCardTable data-qa-label="raceCard-table" isLeg={isLeg}>
                {renderRunnerList(bi, leg, isLeg, tvgRaceId, false)}
              </RaceCardTable>
              {!useNewProgramPageLayout &&
                hasRaceAlertsBar &&
                renderRaceAlerts(!isLeg, tvgRaceId, leg)}
            </RaceCardWrapper>
          ) : (
            !hasRequested && <RacecardMask />
          )}
        </LegCard>
        {talentPicksComp}
        {videoCarouselData &&
          videoCarouselData.raceDate &&
          race.id &&
          race.id.includes(videoCarouselData.raceId) &&
          raceDate === videoCarouselData.raceDate && (
            <VideoSectionWrapper>
              <ComponentSection
                title={videoCarouselData.title}
                noTopPadding
                hasBottomBorder={false}
              >
                <VideoPlaylist disableFetchVideos />
              </ComponentSection>
            </VideoSectionWrapper>
          )}
        {isLogged &&
          numberFirePrediction &&
          hasNumberFirePredictions &&
          showWinProb && (
            <LegCard isLeg={isLeg} numberFireLegCard>
              {get(bettingInterests, "length") > 0 && hasRequested ? (
                <RaceCardWrapper>
                  <NumberFireTable
                    data-qa-label="numberFire-table"
                    isLeg={isLeg}
                  >
                    <NumberFireTitle isRAS={isRAS}>
                      {isSRW ? (
                        <span>Free Picks</span>
                      ) : (
                        <Fragment>
                          {isRAS ? (
                            <RacingAndSports width="125px" />
                          ) : (
                            <NumberFire />
                          )}
                          <span>Predictions</span>
                        </Fragment>
                      )}
                    </NumberFireTitle>
                    {renderRunnerList(bi, leg, isLeg, tvgRaceId, true)}
                  </NumberFireTable>
                </RaceCardWrapper>
              ) : (
                !hasRequested && <RacecardMask />
              )}
            </LegCard>
          )}
        {showWinProb && (
          <NumberFireInfo
            onClick={() =>
              openHelpModal(isRAS ? "Racing and Sports" : "NumberFire Stats")
            }
          >
            <NumberFireText isRAS={isRAS}>
              Stats powered by&nbsp;
              {isRAS ? (
                <RacingAndSports width="98px" />
              ) : (
                <NumberFireIcon>
                  <Icon
                    color={buildColor("grey", "800")}
                    size={12}
                    icon={numberFire}
                  />
                </NumberFireIcon>
              )}
              &nbsp;
              <Icon color={buildColor("grey", "800")} size={12} icon={info} />
            </NumberFireText>
          </NumberFireInfo>
        )}
      </Fragment>
    );
  };

  const renderRaceCard = () => {
    if (bettingInterests.length > 1) {
      return (
        <MagnetScrollArea
          changeShouldUpdate={changeShouldUpdate}
          onHandleTransition={onLegSelect}
          delayUpdate={updatePicks}
          activeIndex={selectedLeg}
          isLoading={false}
          key={`RaceCardWithLeg${bettingInterests.length}`}
          isSlidesCentered={useNewProgramPageLayout}
          setSwipeController={setSwipeController}
        >
          {map(
            bettingInterests,
            (bi: RaceCardBettingInterest[], leg: number) => {
              const raceNumber = +get(race, "raceNumber") + leg;
              const findRace = find(
                races,
                (tempRace) =>
                  tempRace.id ===
                  `${get(race, "track.trackCode")}-${raceNumber}`
              );
              const tvgRaceId = get(findRace, "tvgRaceId", "");

              return (
                <RaceCardLegWrapper
                  data-qa-label="raceCard-leg"
                  key={`RaceCard-leg-${leg + 1}`}
                  isNewLayout={useNewProgramPageLayout}
                  onboardingInfo={showOnboardingInfo && selectedLeg === 0}
                  isPick={bettingInterests.length > 1}
                >
                  {renderLegRaceCard(bi, leg, true, tvgRaceId)}
                </RaceCardLegWrapper>
              );
            }
          )}
          <Fragment>
            {showOnboardingInfo &&
              selectedLeg === 0 &&
              createPortal(
                <FixedMessageContainer isBettingModalOpen={isBettingModalOpen}>
                  <FixedMessage
                    type="info"
                    title="Pick bets are multi-race wagers."
                    text="Select your horse(s) then swipe to the next race"
                  />
                </FixedMessageContainer>,
                // $FlowBug
                parentContainer ?? document.body
              )}
          </Fragment>
        </MagnetScrollArea>
      );
    }

    if (useNewProgramPageLayout) {
      return (
        <RaceCardLegWrapper data-qa-label="raceCard-leg" isSingle>
          {renderLegRaceCard(
            bettingInterests[0],
            0,
            true,
            get(race, "tvgRaceId")
          )}
        </RaceCardLegWrapper>
      );
    }

    return renderLegRaceCard(
      bettingInterests[0],
      0,
      false,
      get(race, "tvgRaceId")
    );
  };

  const renderTutorialBanner = () =>
    infoBannerLink && (
      <FloatingBannerWrapper>
        <FloatingBanner
          type="info"
          link={{
            ...infoBannerLink,
            onClick: () => AlchemerEvents.selectBetTypeTooltip()
          }}
          hasIcon={false}
        />
      </FloatingBannerWrapper>
    );

  const renderLegNavigation = () => (
    <LegNavigatorContainer>
      <FilterBarWrapper
        activeButtons={[selectedLeg]}
        onButtonClick={(value) => {
          if (swipeController) swipeController.slideTo(+value, 350);
          onLegSelect(+value);
        }}
        qaLabel="leg-selector"
      >
        {[...Array(numLegs).keys()].map((leg, index) => (
          <FilterButton value={index}>
            <Paragraph qaLabel={`leg-${index}`} textAlign="center">
              Leg {index + 1}
            </Paragraph>
          </FilterButton>
        ))}
      </FilterBarWrapper>
    </LegNavigatorContainer>
  );

  return useMemo(
    () => (
      <RaceCardSection
        data-qa-label="raceCard-section"
        biLength={bettingInterests.length}
        isPick={bettingInterests.length > 1}
      >
        {enableNewRacePage && renderTutorialBanner()}
        {numLegs && numLegs > 1 && renderLegNavigation()}
        {renderRaceCard()}
      </RaceCardSection>
    ),
    [
      nextRace,
      hasRequested,
      forwardDisabled,
      updatePicks,
      selectedLeg,
      betAmount,
      JSON.stringify(selectedRunners),
      JSON.stringify(props.bettingInterests),
      JSON.stringify(race),
      JSON.stringify(selections),
      numberFirePrediction,
      hasNumberFirePredictions,
      isLogged,
      raceAnalystVerdictExpanded,
      activeBetsCounter,
      showOnboardingInfo,
      group,
      showSilks,
      shouldShowFirstOnboarding,
      isBettingModalOpen,
      parentContainer,
      infoBannerLink,
      isInfoBannerVisible,
      swipeController,
      numLegs
    ]
  );
};

RaceCard.defaultProps = {
  isBettingModalOpen: false,
  bettingInterests: [[]],
  raceTypeCode: "T",
  isWagerable: true,
  selections: [[]],
  isAllSelected: [],
  numColumns: 1,
  onRunnerSelect: noop,
  onAllRunnersSelect: noop,
  selectedLeg: 0,
  onLegSelect: noop,
  legExpandedRunner: [],
  subscribeBaseEvent: noop,
  onSelectAllRunnerEntries: noop,
  isLogged: false,
  renderSortComponent: noop,
  racesData: [[]],
  race: {},
  races: [],
  expandedInfo: noop,
  updatePicks: false,
  changeUpdate: noop,
  hasRequested: false,
  changeShouldUpdate: noop,
  selectedRunners: [[]],
  changeRace: noop,
  openHelpModal: noop,
  openBetReceiptModal: noop,
  hasRaceAlertsBar: false,
  renderRaceAlerts: noop,
  numberFirePrediction: false,
  hasNumberFirePredictions: false,
  showWinProb: true,
  betAmount: 0,
  isSRW: false,
  isRAS: false,
  freePickSource: "handicapping",
  raceAnalystVerdictExpanded: false,
  setRaceAnalystVerdictExpanded: noop,
  useNewProgramPageLayout: false,
  fullWidth: false,
  group: null,
  isResulted: false,
  hasProgramPageActiveBetsReceipt: false,
  activeBetsCounter: 0,
  showOnboardingInfo: false,
  showSilks: false,
  internationalLabel: "Int'l terms",
  shouldShowFirstOnboarding: false,
  onTooltipClick: noop,
  setOnboardingStatus: noop,
  useGraphStatusV2: false,
  enableNewRacePage: false,
  isInfoBannerVisible: false,
  infoBannerLink: undefined,
  onCloseInfoBanner: undefined
};

export default RaceCard;
